/**
 * @param value - The number to round
 * @param maxDecimalPlaces - Maximum number of decimal places (default: 2, clamped to 0-10)
 * @returns The rounded number
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get floorPercent () {
        return floorPercent;
    },
    get parseNumber () {
        return parseNumber;
    },
    get ratioToPercent () {
        return ratioToPercent;
    },
    get toFixed () {
        return toFixed;
    }
});
const toFixed = (value, maxDecimalPlaces = 2)=>{
    const decimalPlaces = Math.min(Math.max(maxDecimalPlaces, 0), 10);
    const multiplier = 10 ** decimalPlaces;
    const roundedValue = Math.round(value * multiplier) / multiplier;
    if (Number.isNaN(roundedValue)) {
        return 0;
    }
    return roundedValue;
};
/**
 * Significant digits kept when converting to a percentage. Well below the precision
 * a double actually carries (~15-17 digits), so binary drift is discarded, and well
 * above anything we display or sort on, so real precision survives.
 */ const PERCENT_SIGNIFICANT_DIGITS = 12;
const withoutFloatDrift = (percent)=>Number.isFinite(percent) ? Number(percent.toPrecision(PERCENT_SIGNIFICANT_DIGITS)) : percent;
const ratioToPercent = (ratio)=>withoutFloatDrift(ratio * 100);
const floorPercent = (percent)=>Math.floor(withoutFloatDrift(percent));
const parseNumber = (value)=>{
    if (typeof value === "number") {
        return value;
    }
    if (!value && value !== 0 || !(typeof value === "string")) {
        return null;
    }
    const asInt = Number(value);
    if (asInt.toString() !== value) {
        return null;
    }
    return asInt;
};
